define([
    'jquery',
    'uiComponent',
    'ko',
    'Magento_Customer/js/customer-data',
], ($, component, ko, customerData) => {
    let self;

    return component.extend({
        size: ko.observable(),
        scale: ko.observable(),
        display: ko.observable(false),

        defaults: {
            template: 'Munro_SizeRecommend/recommended-size',
        },

        initialize: function () {
            self = this;
            this._super();
            this.attachListeners();
            this.dataChangeListener();
        },

        getCart: function() {
            return customerData.get('cart')();
        },

        getLastOrderedItems: function() {
            return customerData.get('last-ordered-items')();
        },

        attachListeners: function () {
            customerData.get('cart').subscribe(this.dataChangeListener);
            customerData.get('last-ordered-items').subscribe(this.dataChangeListener);
        },

        dataChangeListener: function() {
            let sizeInfo = undefined;
            if(self.getCart() && self.getCart().items.length > 0) {
                sizeInfo = self.getCart().items[0]['size_info']
            } else if(self.getLastOrderedItems() && self.getLastOrderedItems().items.length > 0) {
                sizeInfo = self.getLastOrderedItems().items[self.getLastOrderedItems().items.length-1]['size_info']
            }
            if(sizeInfo) {
                self.size(sizeInfo['size']);
                self.scale(sizeInfo['scale']);
                self.display(true);
            } else {
                self.size(null);
                self.scale(null);
                self.display(false);
            }
        }

    });
});
